module.exports = __webpack_public_path__ + "media/Z42.bc52103c.mp3";